<template>
  <div class="w-full">
    <div
      class="flex justify-between"
      :class="[darkMode ? 'text-white lg:text-text-dark' : 'text-text-dark']"
    >
      <label v-if="hasLabel" :for="label" class="mb-1 text-sm font-bold">{{ label }} </label>
      <span v-if="optional" class="text-xs">[{{ optional }}]</span>
    </div>
    <div class="relative w-full">
      <span
        v-if="iconLeft"
        class="absolute left-[18px] top-0 flex h-full items-center justify-center"
      >
        <BaseIcon class="size-5" :icon="iconLeft"></BaseIcon>
      </span>
      <input
        v-if="type != 'textarea'"
        :id="label"
        v-bind="$attrs"
        v-model="inputValue"
        :type="type"
        :placeholder="placeholder"
        class="input-field placeholder-text-dark placeholder-opacity-40"
        :aria-required="!optional ? 'true' : 'false'"
        :required="!optional"
        :aria-invalid="hasError || !!error ? 'true' : 'false'"
        :class="[iconLeft ? 'pl-11' : 'pl-6', hasError || !!error ? 'error' : '']"
        @change="emit('change', inputValue)"
      />
      <textarea
        v-if="type === 'textarea'"
        :id="label"
        v-bind="$attrs"
        v-model="inputValue"
        :type="type"
        :placeholder="placeholder"
        class="input-field placeholder-text-dark placeholder-opacity-40"
        :aria-required="!optional ? 'true' : 'false'"
        :required="!optional"
        :aria-invalid="hasError || !!error ? 'true' : 'false'"
        :class="[iconLeft ? 'pl-11' : 'pl-6', hasError || !!error ? 'error' : '']"
        @change="emit('change', inputValue)"
      ></textarea>
    </div>
    <div v-if="hasError || error || hint" class="mt-1 text-xs">
      <p v-if="hasError && errorText" class="input-error">{{ errorText }}</p>
      <p v-else-if="error" class="input-error">{{ error }}</p>
      <p v-else>{{ hint }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseIcon from '../BaseIcon/BaseIcon.vue'
import type { IBaseInput } from '@/common/components/base/BaseInput/IBaseInput'

const inputValue = defineModel<string | number>()
const emit = defineEmits<{
  (e: 'change', value: string | number | undefined): void
}>()

withDefaults(
  defineProps<
    IBaseInput & {
      hasError?: boolean
      errorText?: string
      darkMode?: boolean
    }
  >(),
  {
    type: 'text',
    placeholder: 'placeholder',
    hasLabel: false,
    error: '',
    hasHint: false,
    optional: '',
    hasError: false,
    errorText: '',
  },
)
</script>

<style scoped>
.input-field {
  @apply w-full rounded-md rounded-tl-none border border-border-light bg-background-03 py-3 pr-6 font-quicksand text-sm font-normal text-text-dark outline-none focus:outline-none focus:ring-2 focus:ring-accent-03 focus:ring-offset-2 disabled:opacity-50;
}

.input-error {
  @apply text-states-error;
}

.input-field.error {
  @apply border-states-error focus:border-border-light focus:ring-states-error;
}

input[type='textarea'],
textarea {
  @apply h-auto min-h-[120px] px-6 py-3;
}
</style>
